import { useState, useEffect } from "react";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import background from "../../assets/images/background.png";
import {
    CHOOSE_PLAN_ROUTE,
    DASHBOARD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    HOME_ROUTE,
    SETUP_ACCOUNT_STEP_ONE_ROUTE,
    SUPER_ADMIN_OTP_ROUTE,
} from "../../routes";
import "./login.scss";
import { auth, emailLoginHandler, logout } from "../../services/firebase";
import { Link } from "react-router-dom";
import { isAuthenticated } from "../../services/firebase";
import axios from "axios";
import dataProvider from "../../services/dataProvider";
import authServices from "../../services/authServices";
import PasswordField from "../common/password-field/password-field";

//

const SuperAdminLogin = ({ history }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(async () => {
        if (isAuthenticated()) {
            history.replace(DASHBOARD_ROUTE);
        } else {
            
        }
    }, []);

    async function handleSubmit(e) {
        setIsLoading(true);
        setError("");

        let result = await emailLoginHandler(e, email, password);

        if (result === true) {
            var config = {
                method: "post",
                url: dataProvider.baseUrl + "superAdminLoginOtp",
                headers: {
                    token: authServices.getToken()
                },
            };

            axios(config)
                .then(function (response) {
                    setIsLoading(false);
                    // console.log("Admin Login OTP", response.data);

                    if(response.data.status === "success") {
                        history.replace({
                            pathname : SUPER_ADMIN_OTP_ROUTE ,
                            state : {
                                otpSent : true
                            }
                        });
                    } else {
                        logout();
                        setError("You don't have access to Super Admin");
                        // history.replace(HOME_ROUTE);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error(error.message);
                });
            
        } else {
            switch (result.code) {
                case "auth/invalid-email":
                    setError("Please Enter a Valid Email Address");
                    break;
                default:
                    setError(result.message);
            }
            setIsLoading(false);
            return false;
        }
    }

    return (
        <div
            id="login-page"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.replace(HOME_ROUTE);
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">Super Admin Login</h1>
                <div className="container-fluid mt-5">
                    {error !== "" && (
                        <div style={{ maxWidth: "32rem" }} className="alert alert-danger mx-auto my-4" role="alert">
                            {error}
                        </div>
                    )}
                    <form className="mx-auto" style={{ maxWidth: "32rem" }} onSubmit={handleSubmit}>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ height: "3rem" }}
                            type="text"
                            placeholder="Email *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                            required
                        />
                        {/* <input
                            onChange={(e) => setPassword(e.target.value)}
                            style={{ height: "3rem" }}
                            type="password"
                            placeholder="Password *"
                            className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                            required
                        /> */}
                        <PasswordField 
                        setState={setPassword}
                        placeholder="Password *"
                        className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                        />
                        <div className="d-flex">
                            <div className="flex-fill d-flex align-items-center">
                                <Link to={FORGOT_PASSWORD_ROUTE}>Forgot Password?</Link>
                            </div>
                            {isLoading ? (
                                <button
                                    style={{ height: "3rem" }}
                                    className="d-flex align-items-center btn btn-outline-light rounded-pill px-5 text-btn"
                                    disabled
                                >
                                    Logging in...
                                    <div className="spinner-border ms-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    style={{ height: "3rem" }}
                                    className=" btn btn-outline-light rounded-pill px-5 text-btn"
                                >
                                    Login
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SuperAdminLogin;
